import { Plus } from '@core/ui';
import { Link } from '@online-webinar/router';
import { useTranslation } from 'react-i18next';

export const CreateWebinarButton = () => {
    const { t } = useTranslation();

    return (
        <div className="relative w-full h-14 mb-4 flex-none">
            <Link
                data-testid="create-webinar-button"
                to="/create"
                className="group absolute top-0 left-0 w-full menu:w-14 menu:hover:w-56 menu:focus-visible:w-56 2xl:hover:w-60 2xl:focus-visible:w-60 h-full bg-primary flex items-center overflow-hidden p-3 rounded-xl text-on-primary transition-[width] duration-200"
                type="button"
            >
                <Plus classNames="size-6 flex-none stroke-current ml-1" />
                <span className="font-w-button ml-2 menu:opacity-0 menu:group-hover:opacity-100 menu:group-focus-visible:opacity-100 whitespace-nowrap transition-opacity duration-200">
                    {t('MainMenu.CreateNew')}
                </span>
            </Link>
        </div>
    );
};
